export type BankVerificationResponse = {
  OriginalAccountNumber?: string;
  OriginalSortCode?: string;
  IsCorrect?: boolean;
  Error?: string | number;
  Cause?: string;
  Description?: string;
  Resolution?: string;
  StatusInformation?: string;
};

/** Only an explicitly valid account can be presented as verified. */
export const getBankVerificationWarning = (
  result: BankVerificationResponse,
): string | null => {
  if (!result.Error && result.IsCorrect === true) return null;

  if (result.Error) {
    return (
      [result.Cause, result.Description, result.Resolution]
        .filter(Boolean)
        .join(' ') ||
      'Bank verification could not be completed. Please try again.'
    );
  }

  return result.IsCorrect === false
    ? `Bank details are invalid${result.StatusInformation ? `: ${result.StatusInformation}` : '.'}`
    : 'Bank verification could not be completed. Please try again.';
};
